import { Button } from "../components";

const SubNavbar = ({
  header = "",
  buttonText = "",
  buttonClick = () => {},
}) => {
  return (
    <section className="subNavbar py-3 mt-0">
      <div className="container d-flex justify-content-between flex-column flex-md-row align-items-md-center row-gap-2">
        <div className="header h2">{header}</div>
        {buttonText && (
          <Button
            text={buttonText}
            click={buttonClick}
            wrapperClassName="col-6 col-md-3 col-xl-2"
          />
        )}
      </div>
    </section>
  );
};

export default SubNavbar;
